function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(61.88 373.338)"
}, "\u201810");

var _ref4 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(136.456 373.338)"
}, "\u201820");

var _ref5 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(209.808 373.338)"
}, "\u201830");

var _ref6 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(280.275 373.338)"
}, "\u201840");

var _ref7 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(36.166 284.961)"
}, "10M");

var _ref8 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(53.274 351.31)"
}, "0");

var _ref9 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(33.475 214.83)"
}, "20M");

var _ref10 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(33.527 144.701)"
}, "30M");

var _ref11 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(32.266 74.572)"
}, "40M");

var _ref12 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(31.473 10.716)"
}, "Pop.");

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M145.8 1.3v350"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M219.2 1.3v350"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fb7d74",
  strokeMiterlimit: 10,
  d: "M263.4 1.3v350"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M292.5 1.3v350"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 316.3h219"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 281.3h219"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 246.3h219"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 211.3h219"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 176.3h219"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 141.3h219"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 106.3h219"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 71.3h219"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 36.3h219"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.3 36.3h219"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M73.1 1.3h219.4v350H73.1z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fb7d74",
  d: "M235.8 165.3h50.6v22h-50.6z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(245.492 180.125)"
}, "2036");

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  id: "Line",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 5.035,
  d: "M73.3 175.3l7.3-3 7.3-3 7.3-3.1 7.3-3.1 7.3-3.1 7.3-3.2 7.3-3.2 7.3-3.3 7.3-3.3 7.3-3.4 7.3-3.4 7.3-3.5 7.3-3.5 7.3-3.6 7.3-3.6 7.3-3.7 7.3-3.7 7.3-3.8 7.3-3.8 7.3-3.8 7.3-3.9 7.3-3.9 7.3-3.9 7.3-4 7.3-4 7.3-4.1"
});

var _ref31 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bottom_x5F_label"
}, React.createElement("path", {
  fill: "#fff",
  d: "M81.7 183.3h83v20.9h-83z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(89.047 197.625)"
}, "25 million"));

var _ref32 =
/*#__PURE__*/
React.createElement("g", {
  id: "Top_x5F_label"
}, React.createElement("path", {
  fill: "#fff",
  d: "M173 53.8h83v22h-83z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(180.319 68.625)"
}, "38 million"));

var SvgS15MobileColors = function SvgS15MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "viz",
    x: 0,
    y: 0,
    viewBox: "0 0 300 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

export default "data:image/svg+xml;base64,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";
export { SvgS15MobileColors as ReactComponent };